import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import BackgroundSelector from '../../../itrust_common/components/others/BackgroundSelector';
import Support from '../../../support/Support';
import Permission from '../../others/permissionAuth/Permission.js';
import { hasKeyValueWithSkipKey } from '../../../itrust_common/components/HelperFunctions';
import PreferencesModal from '../perferences/PreferencesModal';
import { onBoardingTourInfoUpdate } from '../../../redux/actions/onBoardingActions';
import { connect, useDispatch } from 'react-redux';
import { getAddOnDefaultServiceURL } from '../../../containers/authorised/addOns/other/AddOnsHelperFunctions';
import { useLocation } from 'react-router-dom';
import AppPopUps from '../../../other/AppPopUps.js';
import CallPopUp from '../../../containers/authorised/addOns/voip/voipPopUp/popUp/CallPopUp.js';

let sidebarMenu = [
  { title: 'Dashboard', icon: 'la-dashboard', path: '/dashboard' },
  { title: 'Appointments', icon: 'la-calendar', path: '/appointment', moduleName: 'appointments', action: 'can_view' },
  { title: 'Exams', icon: 'la-stethoscope', path: '/exam', moduleName: 'exams', action: 'can_view' },
  { title: 'Orders', icon: 'la-shopping-cart', path: '/order', moduleName: 'orders', action: 'can_view' },
  { title: 'Patients', icon: 'la-user-plus', path: '/patients', moduleName: 'patients', action: 'can_view' },
  { title: 'Reports', icon: 'la-notes-medical', path: '/report', moduleName: 'reports', action: 'can_view' },
  { title: 'Payments', icon: 'la-dollar-sign', path: '/payment-report', moduleName: 'payment_reports', action: 'can_view' },
  // { title: 'Campaign', icon: 'la-comment', path: '/campaign', moduleName: 'campaigns', action: 'can_view' },
  { title: 'Marketing', icon: 'la-bullhorn', path: '/marketing-blast', moduleName: 'marketing', action: 'can_view', newFeature: true },
  { title: 'Logs', icon: 'la-file-text-o', path: '/logs', moduleName: 'logs', action: 'can_view' },
  { title: 'Settings', icon: 'la-gear', path: '/settings', onlyAdmin: "super_admin" }
];

const Sidebar = (props) => {
  const { organisation, totalAmount, isTourActive, marketingBlastEnabled } = props
  const [sideMenuBar, setSideMenuBar] = useState(sidebarMenu)
  const [isAddOnActive, setIsAddOnActive] = useState(false)
  const dispatch = useDispatch()
  const location = useLocation()

  useEffect(() => {
    const val = window.location.pathname.includes('/add-ons/') ?? false
    if (val !== isAddOnActive) {
      setIsAddOnActive(val)
    }
  }, [location])

  const handleActivePatientTour = () => {
    if (isTourActive) {
      setTimeout(() => dispatch(onBoardingTourInfoUpdate({ stepIndex: 1, isTourActive: true })), 600);
    }
  }

  const getSideMenu = () => {
    let itrust_pay = organisation?.add_ons_config?.type?.itrust_pay
    const shouldIncludeAddOns = hasKeyValueWithSkipKey(organisation?.add_ons_config?.type, 'visible', true)
    if (shouldIncludeAddOns) {
      if (sidebarMenu[9].title !== 'Add-ons') {
        sidebarMenu.splice(-1, 0, {
          title: 'Add-ons',
          icon: 'las la-crown',
          path: `${getAddOnDefaultServiceURL(organisation?.add_ons_config?.type)}`,
          moduleName: 'addOns',
          action: 'can_view',
          badge: (itrust_pay?.visible && itrust_pay?.status !== 'inactive' && !itrust_pay?.account_info?.id && totalAmount) ? true : false
        });
      }
      return sidebarMenu
    }
    else {
      if (sidebarMenu[9].title === 'Add-ons') {
        sidebarMenu.splice(9, 1);
      }
      return sidebarMenu
    }
  }

  useEffect(() => {
    setSideMenuBar(getSideMenu())
  }, [organisation?.add_ons_config?.type, getSideMenu()])

  const visibleMenuItems = sideMenuBar.filter(item =>
    item.moduleName !== 'marketing' || marketingBlastEnabled
  )

  return (
    <>
      <div>
        <div className={`menubar bg-white text-center position-fixed h-100 border-right sidebar-height overflow-auto hidden-scroll`}>
          {visibleMenuItems.map(item => (
            <Permission onlyAdmin={item.onlyAdmin} moduleName={item.moduleName} action={item.action} key={item.moduleName} noSupportPageNotFound={true}>
              <NavLink to={item.path} activeClassName={`active sidebar-active-module`} isActive={(match, location) => { const patientPaths = [ '/patients', '/recent-patients', '/patients-surveys', ]; return item.title === 'Patients' ? patientPaths.includes(location.pathname) : match; }} onClick={item.title === 'Patient' && handleActivePatientTour} className={`${(isAddOnActive && item.moduleName == 'addOns') && 'active'}`}>
                <div className={`py-3 mb-3 quick-action-hover ${item.title === 'Patient' && 'patient-step-1'}`}>
                  <i className={`la ${item.icon} menu-icon`} />
                  {(item.badge) && <span className="circle-10 bg-danger rounded-circle position-absolute ml-1 mb-9 "></span>}
                  <h6 className="menu-title pt-1">{item.title}</h6>
                  {item.newFeature && <strong class="badge badge-danger font-size-12">New</strong>}
                </div>
              </NavLink>
            </Permission>
          ))}
        </div>
        <PreferencesModal />
        <BackgroundSelector />
      </div>
      <div className="support-icon">
        <Support />
        <CallPopUp />
        <AppPopUps />
      </div>
    </>
  );
};

const mapStateToProps = state => {
  const { organisation: { organisation } } = state
  return {
    marketingBlastEnabled: organisation.preferences?.marketing_blast?.active
  }
}

export default connect(mapStateToProps)(Sidebar);